
import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BudgetContext } from '../context';
import { EXPENSE_SAMPLES, INCOME_SAMPLES } from '../helpers/constants';
import { GREEN, RED } from '../helpers/constants/colors';
import { sum } from '../helpers/functions/math';
import BudgetTable from './BudgetTable';

const Tables = ({ 
    deleteRow =[], 
    clear = [],
    addEntry = [],
    nameChange = [],
    valueChange = [],
    nameSelect =[]
}) =>{
    const {incomes, expenses} = useContext(BudgetContext)
    return (
            <Row>
                <Col>
                    <BudgetTable
                        type="Income"
                        variant={GREEN}
                        items={incomes}
                        sum={sum(incomes)}
                        deleteRow={deleteRow[0]}
                        clearAll={clear[0]}
                        addEntry={addEntry[0]}
                        onNameChange={nameChange[0]}
                        onValueChange={valueChange[0]}
                        onNameSelect={nameSelect[0]}
                        samples={INCOME_SAMPLES}/>
                </Col>
                <Col>
                    <BudgetTable
                        type="Expense"
                        variant={RED}
                        items={expenses}
                        sum={sum(expenses)}
                        deleteRow={deleteRow[1]}
                        clearAll={clear[1]}
                        addEntry={addEntry[1]}
                        onNameChange={nameChange[1]}
                        onValueChange={valueChange[1]}
                        onNameSelect={nameSelect[1]}
                        samples={EXPENSE_SAMPLES}/>
                </Col>
            </Row>
    )
}



export default Tables;
